<template>
    <div>
      <div class='titlelist'>
        <div v-for='(v,i) in list' :key='i+"101"' @click='handclick(i,v)' :style="{borderRight:(i+1)<list.length?'1px solid #d8d8d8':'',padding: islang=='eng'?'0 1rem':'0 2.4rem'}">
        <span :style="{borderBottom:isright==i?'3px solid #09666E':'',color:isright==i?'#09666E':''}">{{islang=='eng'?v.name_en:v.name}}</span>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['isnum'],
    data(){
      return{
        islang : window.localStorage.guanwanglang,
        list:[
        {name:'開立帳戶',url:'/apply_in_person_individual',name_en:'Account Opening'},
        {name:'數據服務',url:'/market_data',name_en:'Market Data Service'},
        {name:'資金存取',url:'/deposit&withdrawal',name_en:'Deposit & Withdrawal'},//  
        {name:'表格下載',url:'/download_form',name_en:'Download Form'},
        {name:'常見問題',url:'/FAQs',name_en:'FAQs'},//
        {name:'市場假期',url:'/market_holiday',name_en:'Market Holiday'},
        {name:'交易通告',url:'/trading_announcement',name_en:'Trading Announcement'},],
        // {name:this.$lang.gzjq,url:'/market_holiday',name_en:this.$lang.gzjq},
        // {name:this.$lang.jytg,url:'/trading_announcement',name_en:this.$lang.jytg},],
        isright:0
      }
    },
    watch:{
      isnum:{
        immediate:true,
        handler(ev){
          this.isright = this.isnum || 0
        }
      }
    },
    mounted() {
      document.documentElement.scrollTop = 0;
      //javascript:window.history.forward(1);
    },
    methods:{
      handclick(i,v){
        this.isright = i
        if(v.url){
          this.$router.push(v.url)
        }
      },
    }
  }
</script>
<style>
  .look_g{
    position: relative !important;
    left: -14.4px !important;
  }
</style>
<style scoped>
  .titlelist{
    /* display: flex;
    justify-content: space-between; */
    text-align: center;
    font-size: 16px;
    margin-bottom: 1.5rem;
    margin-left: -1rem;
  }
  .titlelist div{
    display: inline-block;
    font-size: 18px;    color: #000;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/assetmanage/titlelist.vue